import React from "react"
import Fa from 'react-fontawesome'

export default class CurrentImage extends React.Component {

  render() {
            var _imageStyle, _overlayStyle
        if (this.props.landscape) {
            _overlayStyle = {minWidth: '96%', maxWidth:'96%'}
            _imageStyle = {maxWidth: '715px', maxHeight:'715px'}
        }
        else {
            _overlayStyle = {minWidth: '96%', maxWidth:'96%'}
            _imageStyle =  {maxWidth: '715px', maxHeight:'715px', display: 'block', margin: '0 auto'}
        }


        var overlay
        if (this.props.previewOverlay) {
          overlay = <div className='overlay' style={_overlayStyle}>
                        <h3><Fa name='cog' spin />&nbsp;Generating preview...</h3>
                        <h4>Please wait, it will take few seconds.</h4>
                    </div>
        }
        else if (this.props.publishOverlay) {
          overlay =  <div className='overlay' style={_overlayStyle}>
                        <h3><Fa name='cog' spin />&nbsp;Publishing to Picosign...</h3>
                        <h4>Please wait, it will take few seconds.</h4>

                     </div>
        }
        else if (this.props.saveOverlay) {
          overlay =  <div className='overlay' style={_overlayStyle}>
                        <h3><Fa name='cog' spin />&nbsp;Saving image to Library...</h3>
                        <h4>Saving your image to image library.</h4>
                        <h4>Please wait, it will take few seconds.</h4>

                     </div>
        }
        else if (this.props.savePublishOverlay) {
          overlay =  <div className='overlay' style={_overlayStyle}>
                        <h3><Fa name='cog' spin />&nbsp;Publishing to Picosign...</h3>
                        <h4>Original image is being saved to the image library.</h4>
                        <h4>Please wait, it will take few seconds.</h4>
                     </div>
        }

        else if (this.props.publishSuccessOverlay) {
          overlay = <div className='overlay' style={_overlayStyle}>
                      <h3><Fa name='check' className="mpico-color" />&nbsp;Image was published.</h3>
                      <h4>It will appear on your PicoSign on the next scheduled connection.</h4>
                      <h4>
                        <button className="btn btn-success" onClick={this.props.startOver}>Continue</button>   
                        {/* <button className="btn btn-success" onClick={this.props.startOver}>Current image</button> */}
                      </h4>
                    </div>
        }

        else if (this.props.saveSuccessOverlay) {
          overlay = <div className='overlay' style={_overlayStyle}>
                      <h3><Fa name='check' className="mpico-color" />&nbsp;Image was saved to your media library.</h3>
                      <h4>You can publish it straight from the library at any time</h4>
                      <h4>
                        <button className="btn btn-success" onClick={this.props.startOver}>Continue</button>   
                        {/* <button className="btn btn-success" onClick={this.props.startOver}>Current image</button> */}
                      </h4>
                    </div>
        }
        else if (this.props.publishFailureOverlay) {
          overlay = <div className='overlay' style={_overlayStyle}>
                        <h3><Fa name='times' className="error-color" />&nbsp;Image processing error</h3>
                        <h4>Please try again.</h4>
                        <h4>If the problem persists, please contact our support team.</h4>
                        <h4>
                            <button className="btn btn-success" onClick={this.props.startOver}>Continue</button>
                        {/* <button className="btn btn-success" onClick={this.props.startOver}>Current image</button> */}
                        </h4>
                    </div>
        } 

        return (
            <div>
              <img src={this.props.src} style={_imageStyle} className='previewImage' alt='preview' />
              {overlay}
            </div>
        )
  }
}


// WEBPACK FOOTER //
// ./src/components/CurrentImage.js